import { IAddress } from 'features/Address'

export const sortingThAddress = (
  list: IAddress,
  lang = 'th' as string,
): IAddress => {
  return list.sort((current, next) =>
    current.native.localeCompare(next.native, lang),
  )
}
